export default {
  workOrderListApi: {
    list: {
      findStatusOptions: 'api/myOrderList/findStatusOptions',
      myCreatedList: 'api/myOrderList/myCreatedList',
      delWorkOder: 'api/myOrderList/delWorkOder',
      createdSimple: 'api/myOrderList/createdSimple',
      saveOrUpdateWorkOder: 'api/myOrderList/saveOrUpdateWorkOder',
      searchWorkOrder: 'api/myOrderList/searchWorkOrder',
      revokeWorkOder: 'api/myOrderList/revokeWorkOder'
    },
    process: {
      // 流程
      processDetail: 'api/orderProcessList/processDetail',
      processList: 'api/orderProcessList/processList',
      submitHandleResult: 'api/orderProcessList/submitHandleResult',
      personList: 'api/orderProcessList/personList/',
      thirdPartyOptions: 'api/orderProcessList/thirdPartyOptions',
      handleUserList: 'api/orderProcessList/handleUserList',
      delay: 'api/orderProcessList/delay',
      urgingWorkOrder: 'api/orderProcessList/urgingWorkOrder',
      findRoleOptions: 'api/orderProcessList/findRoleOptions',
    },
    search: {
      findList: 'api/orderSearchList/findList',
    }
  }
}